import { Box, Button } from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import { motion } from "framer-motion";

export default function DecrementButton({ weight, handleDecrementWeight }) {
  const subtract5 = () => {
    handleDecrementWeight(parseInt(!weight ? 0 : weight) - 5);
  };

  return (
    <Box
      sx={{
        maxWidth: "125px",
        mx: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1,
        borderRadius: 2,
      }}
      component={motion.div}
      layout
    >
      <Button
        variant="contained"
        color="primary"
        onClick={subtract5}
        startIcon={<RemoveIcon />}
        aria-label="Increment by 5 percent"
        sx={{ width: "125px" }}
      >
        5
      </Button>
    </Box>
  );
}
